function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import etask from '../../../util/etask.js';
import zutil from '../../../util/util.js';
// XXX sergeir: import here, so webpack will include it in the bundle
import '../../../util/zdot.js';
var is_node = typeof module == 'object' && module.exports;
export var routes_by_host = {
  'oculus.toolip.io': [{
    path: '*',
    component: '/www/oculus/pub/pages/oculus.toolip.io/404.tsx'
  }]
};
var create_async_component = (module_path, r_object, Data_context) => {
  var _Async_component;
  var Component = null;
  return _Async_component = class Async_component extends React.Component {
    constructor() {
      super();
      this.state = {
        Component
      };
      var _this = this;
      etask(function* () {
        yield Async_component.load();
        _this.context.reset();
        if (_this.state.Component !== Component) _this.setState({
          Component
        });
      });
    }
    render() {
      if (this.state.Component) return /*#__PURE__*/React.createElement(this.state.Component, this.props);
      return /*#__PURE__*/React.createElement("div", {
        className: "component-preloader"
      });
    }
  }, _defineProperty(_Async_component, "contextType", Data_context), _defineProperty(_Async_component, "load", () => etask(function* () {
    var module;
    var module_name = module_path.replace('/www/oculus/pub/', '');
    var et = etask.wait();
    import(/* webpackExclude: /Jakefile\.js$/ */
    /* webpackInclude: /\.(tsx|js)$/ */
    '/www/oculus/pub/' + module_name).then(m_res => {
      module = m_res;
      et.continue();
    }).catch(e => {
      if (window.reload_on_chunk_error) location.reload();
    });
    yield et;
    Component = module.Root;
    Object.assign(r_object, Component.meta, {
      loaded: true
    });
    if (r_object && r_object.on_load) r_object.on_load();
  })), _Async_component;
};
var get_component = (route, opt, r_object, Data_context) => {
  if (is_node && route.no_ssr) return null;
  var comp = route.component;
  if (typeof comp != 'string') return comp;
  return is_node ? require('../../../' + comp).Root : create_async_component(comp, r_object, Data_context);
};
var app_routes = {};
var get_component_node_webpack = (route, opt) => {
  if (is_node && route.no_ssr) return null;
  var comp = route.component;
  if (typeof comp != 'string') return comp;
  var module_name = comp.replace('/www/oculus/pub/', '');
  return import(/* webpackExclude: /Jakefile\.js$/ */
  /* webpackInclude: /\.(tsx|js)$/ */
  '/www/oculus/pub/' + module_name).then(m_res => {
    return m_res.Root;
  });
};
export var get_app_routes = (App, opt, Data_context) => {
  var settings_conf = zutil.get(opt.www_hola, 'routes', {});
  var settings = settings_conf[opt.host] || settings_conf.default || {
    root: 'oculus.toolip.io'
  };
  if (!app_routes[settings.root]) {
    app_routes[settings.root] = [];
    var r_by_host = routes_by_host[settings.root];
    var raw_routes_ = r_by_host.slice(0, r_by_host.length - 1).concat(opt.dynamic_routes || []).concat([r_by_host[r_by_host.length - 1]]);
    // XXX dmitriiz: move 404 page to the end
    raw_routes_.forEach(r => {
      var r_obj = Object.assign({}, r);
      if (r_obj.path == '*') r_obj.path = undefined;
      r_obj.component = get_component(r, opt, r_obj, Data_context);
      app_routes[settings.root].push(r_obj);
    });
  }
  var final = app_routes[settings.root];
  return [{
    component: App,
    routes: final.filter(r => !r.disabled || !r.disabled(opt))
  }];
};
export var _get_prepared = (App, opt, app_routes_2) => {
  var final = app_routes_2;
  return [{
    component: App,
    routes: final.filter(r => !r.disabled || !r.disabled(opt))
  }];
};
export var get_app_routes_node = (App, opt) => {
  var settings_conf = zutil.get(opt.www_hola, 'routes', {});
  var settings = settings_conf[opt.host] || settings_conf.default || {
    root: 'oculus.toolip.io'
  };
  if (!app_routes[settings.root]) {
    app_routes[settings.root] = [];
    var r_by_host = routes_by_host[settings.root];
    var raw_routes_ = r_by_host.slice(0, r_by_host.length - 1).concat(opt.dynamic_routes || []).concat([r_by_host[r_by_host.length - 1]]);
    // XXX dmitriiz: move 404 page to the end
    var promises = [];
    raw_routes_.forEach((r, i) => {
      var r_obj = Object.assign({}, r);
      if (r_obj.path == '*') r_obj.path = undefined;
      var cmp_promise = get_component_node_webpack(r_obj, opt);
      cmp_promise.then(component => {
        if (!component) return;
        app_routes[settings.root][i] = Object.assign(r_obj, {
          component
        }, component.meta ? component.meta : {}, {
          loaded: true
        });
      });
      promises.push(cmp_promise);
    });
    return Promise.all(promises).then(() => {
      return _get_prepared(App, opt, app_routes[settings.root], settings);
    });
  }
  return new Promise(resolve => {
    resolve(_get_prepared(App, opt, app_routes[settings.root], settings));
  });
};